import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Alert, CircularProgress } from '@mui/material';
import { apiError } from '../../utils/format';

// Confirmation for irreversible actions. onConfirm returns a promise; the dialog stays open and
// shows the server's error if it fails, and cannot be submitted twice.
const ConfirmDialog = ({ open, title, text, confirmLabel = 'Подтвердить', danger = false, onConfirm, onClose }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setBusy(true);
    setError('');
    try {
      await onConfirm();
      onClose(true);
    } catch (e) {
      setError(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !busy && onClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: 'text.primary' }}>{text}</DialogContentText>
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} disabled={busy}>Отмена</Button>
        <Button
          variant="contained"
          color={danger ? 'error' : 'primary'}
          onClick={handleConfirm}
          disabled={busy}
          startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
